import React, { useState } from 'react';
import Icon from '../ui/AppIcon';
import { usePWA } from '../../hooks/usePWA';

export default function PWAInstallFAB() {
  const { isInstalled, requestInstall, isInstallPending, showIOSInstall } = usePWA();
  const [isInstalling, setIsInstalling] = useState(false);

  if (isInstalled) return null;

  const handleClick = async () => {
    setIsInstalling(true);
    try {
      await requestInstall();
    } finally {
      setIsInstalling(false);
    }
  };

  const busy = isInstalling || isInstallPending;

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={busy || showIOSInstall}
      className={`pwa-install-fab lg:hidden ${showIOSInstall ? 'invisible pointer-events-none' : ''}`}
      aria-hidden={showIOSInstall}
      tabIndex={showIOSInstall ? -1 : 0}
      aria-label="Install Patel Sales app"
    >
      <Icon name="ArrowDownTrayIcon" size={20} />
      <span>{busy ? '...' : 'Install App'}</span>
    </button>
  );
}
